export var Button = _ref => {
  var {
    borderRadius
  } = _ref;
  return () => ({
    keyboardFocusStyle: {
      borderRadius: borderRadius + 3
    },
    viewStyle: {
      borderRadius
    }
  });
};
//# sourceMappingURL=Button.js.map